import React from "react";
import PropTypes from "prop-types";
import {
  classStringBuilder,
  conditionallyAddStyles,
} from "../support/helpers";
import { useSelector } from "react-redux";
import { selectFinishedEditing } from "../customisation-slice";

const propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.node).isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  className: "",
};

const SidebarActionButtons = ({ buttons, className }) => {
  const finishedEditing = useSelector(selectFinishedEditing);

  const defaultClasses = [
    "grid",
    "md:grid-cols-1",
    "gap-4",
    "p-4",
    "md:p-8",
    "border-t",
    "border-light-grey",
  ];

  const additionalClasses = className.split(" ");

  conditionallyAddStyles(
    buttons.length > 1 && !finishedEditing,
    additionalClasses,
    "grid-cols-2",
    "grid-cols-1"
  );

  const classes = classStringBuilder(defaultClasses, additionalClasses);

  return (
    <div className={classes}>
      {buttons.map((button) => (
        <div key={button.key}>{button}</div>
      ))}
    </div>
  );
};

SidebarActionButtons.propTypes = propTypes;

SidebarActionButtons.defaultProps = defaultProps;

export default SidebarActionButtons;
